module.exports = __webpack_public_path__ + "static/media/example_symm3.b02232ad.bmp";